import { css } from '@/styled-system/css';

export const barStyles = css.raw({
  gridRow: 1,
  borderWidth: '4px',
  borderStyle: 'solid',
  borderRadius: '10px',
});

export const iconContainerStyles = css.raw({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  marginTop: '50',
  border: '8px solid rgba(7, 77, 255, 0.1)',
  position: 'absolute',
  height: '900',
  width: '900',
  top: '{spacing.-400}',
  marginLeft: '45%',
});

export const iconBackgroundStyles = css.raw({
  borderRadius: '50%',
  border: '6px solid {colors.border.onHero.neutral}',
  borderStyle: 'solid',
  height: '27px',
  width: '27px',
  color: 'text.onHero.neutral',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'bg.neutral',
  boxShadow: '0px 2px 4px rgba(33, 29, 29, 0.2)',
});

export const dataPointContainerStyles = css.raw({
  borderRadius: '50%',
  marginTop: '2px',
  border: '8px solid rgba(7, 77, 255, 0.1)',
  position: 'absolute',
  top: '40px',
});

export const dataPointStyles = css.raw({
  borderRadius: '50%',
  border: '6px solid {colors.border.onHero.neutral}',
  height: '20px',
  width: '20px',
  color: 'text.onHero.neutral',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'bg.accent.brand.hero',
  boxShadow: '0px 2px 4px rgba(33, 29, 29, 0.2)',
});
